import { z } from 'zod';
const KpisSchema = z.object({
    reservasCreadasHoy: z.number(),
    clasesDelDia: z.number(),
    clasesSinAsignar: z.number(),
    ingresosDelDia: z.coerce.number(),
    egresosDelDia: z.coerce.number(),
});
const ClaseDelDiaSchema = z.object({
    id: z.string().uuid(),
    fechaHoraInicio: z.string(),
    duracionHoras: z.number(),
    estado: z.string(),
    tipoClase: z.string(),
    disciplina: z.string().nullable().optional(),
    empleadoId: z.string().uuid().nullable().optional(),
    empleadoNombre: z.string().nullable().optional(),
});
const UltimaReservaSchema = z.object({
    id: z.string().uuid(),
    codigo: z.string(),
    cliente: z.string(),
    totalNeto: z.coerce.number(),
    totalPagado: z.coerce.number().optional(),
    // Estado de pago derivado (sin tocar DB).
    pagoEstado: z.enum(['pagado', 'parcial', 'pendiente']).optional(),
    estado: z.string(),
    // Lista (string_agg) de tipos de clase de la reserva, p. ej.
    // "GRUPAL, PRIVADA". Puede ser null si la reserva todavía no tiene
    // clases asociadas.
    tipoClase: z.string().nullable().optional(),
    creadoEn: z.string(),
});
const DiaBalanceSchema = z.object({
    fecha: z.string(),
    ingresos: z.coerce.number(),
    egresos: z.coerce.number(),
    neto: z.coerce.number().optional(),
});
export const DashboardResumenSchema = z.object({
    fecha: z.string(),
    kpis: KpisSchema,
    clasesDelDia: z.array(ClaseDelDiaSchema),
    clasesSinAsignar: z.array(ClaseDelDiaSchema),
    ultimasReservas: z.array(UltimaReservaSchema),
    balanceDias: z.array(DiaBalanceSchema),
    balanceDiasRango: z.number().optional(),
});
// ---------------- Dashboard promotor externo --------------------
const KpisPromotorSchema = z.object({
    reservasMes: z.number(),
    comisionDevengadaMes: z.coerce.number(),
    comisionPendiente: z.coerce.number(),
});
// El backend no expone totalNeto ni paga al promotor externo: el monto
// de la reserva sólo se ve en el detalle, no en listados/dashboard.
const ReservaPromotorSchema = z.object({
    id: z.string().uuid(),
    codigo: z.string(),
    cliente: z.string(),
    estado: z.string(),
    pctEfectiva: z.coerce.number().nullable(),
    comisionEstimada: z.coerce.number().nullable(),
    creadoEn: z.string(),
});
const ComisionMesSchema = z.object({
    /** YYYY-MM */
    mes: z.string(),
    total: z.coerce.number(),
});
export const DashboardPromotorSchema = z.object({
    promotorId: z.string().uuid(),
    rangoMes: z.object({ desde: z.string(), hasta: z.string() }),
    kpis: KpisPromotorSchema,
    ultimasReservas: z.array(ReservaPromotorSchema),
    comisionesPorMes: z.array(ComisionMesSchema).optional(),
});
